import React from "react";

interface HeroProps {
  image: string;
  text: string;
}

const Hero: React.FC<HeroProps> = ({ image, text }) => {
  // Split the text into two parts - assuming text is "Välkommen till Lada Basteskår"
  const textParts = text.split("Lada");
  const firstPart = textParts[0]; // "Välkommen till "
  const secondPart = textParts[1] ? `Lada${textParts[1]}` : ""; // "Lada Basteskår"

  return (
    <div className="relative w-full h-[80vh]">
      {/* Hero Image */}
      <img
        className="w-full h-full object-cover"
        src={image}
        alt="Hero Banner"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40">
        {/* Text Container */}
        <div className="container mx-auto h-full">
          <div className="flex flex-col justify-end h-[70%] md:pl-48 pl-6">
            <h1
              className="md:text-7xl text-5xl font-bold text-white"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            >
              {firstPart}
              <br />
              {secondPart}
            </h1>
            <div className="mt-4">
              <a href="/omoss" rel="noopener noreferrer">
                <button className="px-8 py-2 bg-darkBlue hover:bg-hoverBlue text-white text-lg font-bold rounded-md hover:bg-hoverBluetransition duration-300">
                  Om oss
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
